export class MarkdownConverter {
  static toHtml(markdown: string): string {
    if (!markdown) return '';

    let html = markdown;

    // Convert <br> tags to newlines for consistent line processing
    html = html.replace(/<br\s*\/?>/gi, '\n');

    // Convert bold (**text** or __text__)
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');

    // Convert italic (*text* or _text_)
    html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    html = html.replace(/_([^_]+)_/g, '<em>$1</em>');

    // Convert links [text](url)
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

    // Split into lines for list processing
    const lines = html.split('\n');
    const result: string[] = [];
    let inOrderedList = false;
    let inUnorderedList = false;

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      // Check for ordered list (1. 2. 3. etc.)
      const orderedMatch = line.match(/^(\d+)\.\s+(.+)$/);
      if (orderedMatch) {
        if (!inOrderedList) {
          if (inUnorderedList) {
            result.push('</ul>');
            inUnorderedList = false;
          }
          result.push('<ol>');
          inOrderedList = true;
        }
        result.push(`<li>${orderedMatch[2]}</li>`);
        continue;
      }

      // Check for unordered list (- or * or +)
      const unorderedMatch = line.match(/^[-*+]\s+(.+)$/);
      if (unorderedMatch) {
        if (!inUnorderedList) {
          if (inOrderedList) {
            result.push('</ol>');
            inOrderedList = false;
          }
          result.push('<ul>');
          inUnorderedList = true;
        }
        result.push(`<li>${unorderedMatch[1]}</li>`);
        continue;
      }

      // Close any open lists if we hit a non-list line
      if (inOrderedList) {
        result.push('</ol>');
        inOrderedList = false;
      }
      if (inUnorderedList) {
        result.push('</ul>');
        inUnorderedList = false;
      }

      // Regular paragraph or empty line
      if (line) {
        result.push(`<p>${line}</p>`);
      }
    }

    // Close any remaining open lists
    if (inOrderedList) {
      result.push('</ol>');
    }
    if (inUnorderedList) {
      result.push('</ul>');
    }

    return result.join('\n');
  }

  static toMarkdown(html: string): string {
    if (!html) return '';

    let markdown = html;

    // Convert strong tags to **
    markdown = markdown.replace(/<strong[^>]*>([^<]+)<\/strong>/g, '**$1**');
    markdown = markdown.replace(/<b[^>]*>([^<]+)<\/b>/g, '**$1**');

    // Convert em tags to *
    markdown = markdown.replace(/<em[^>]*>([^<]+)<\/em>/g, '*$1*');
    markdown = markdown.replace(/<i[^>]*>([^<]+)<\/i>/g, '*$1*');

    // Convert links
    markdown = markdown.replace(/<a[^>]*href=["']([^"']+)["'][^>]*>([^<]+)<\/a>/g, '[$2]($1)');

    // Convert paragraphs
    markdown = markdown.replace(/<p[^>]*>([^<]+)<\/p>/g, '$1\n');

    // Convert lists
    markdown = markdown.replace(/<ol[^>]*>([\s\S]*?)<\/ol>/g, (match, content) => {
      const items = content.match(/<li[^>]*>([^<]+)<\/li>/g) || [];
      return items.map((item: string, index: number) => {
        const text = item.replace(/<li[^>]*>([^<]+)<\/li>/, '$1');
        return `${index + 1}. ${text}`;
      }).join('\n') + '\n';
    });

    markdown = markdown.replace(/<ul[^>]*>([\s\S]*?)<\/ul>/g, (match, content) => {
      const items = content.match(/<li[^>]*>([^<]+)<\/li>/g) || [];
      return items.map((item: string) => {
        const text = item.replace(/<li[^>]*>([^<]+)<\/li>/, '$1');
        return `- ${text}`;
      }).join('\n') + '\n';
    });

    // Clean up extra newlines
    markdown = markdown.replace(/\n{3,}/g, '\n\n');
    markdown = markdown.trim();

    return markdown;
  }
}
